import ResponsiveCoverLink from "components/Cover/ResponsiveCoverLink";
import CurrentlyReadingProgress from "./CurrentlyReadingProgress/CurrentlyReadingProgress";
import CurrentlyReadingBookDetails from "./CurrentlyReadingBookDetails/CurrentlyReadingBookDetails";
import CircleBookProgress from "components/progress/CircleProgress/CircleProgress";
import { EditionSerializersEdition, LetterbooksSerializersBook, UserBookSerializersUserBook, UserBookSerializersUserBookDate } from "types/serializers";

export default function CurrentlyReadingCardContent({
  book,
  edition,
  isOwner,
  userBook,
  userBookRead,
  trackRead,
  onProgressChange,
}: {
  book: LetterbooksSerializersBook;
  edition?: EditionSerializersEdition;
  isOwner: boolean;
  userBook: UserBookSerializersUserBook;
  userBookRead?: UserBookSerializersUserBookDate;
  onProgressChange?: (newProgress: number) => Promise<any>;
  trackRead?: () => void;
}) {
  return (
    <div className="w-full p-4 bg-card rounded my-20 flex flex-col">
      <div className="flex flex-row gap-4 justify-between items-start">
        <div className="flex flex-col gap-4 w-full">
          <div className="flex flex-row w-full justify-between gap-4 items-start">
            <CurrentlyReadingBookDetails
              book={book}
              edition={userBookRead?.edition || userBook?.edition || edition}
            />
            <div className="hidden lg:block">
              <CircleBookProgress progress={userBookRead?.progress || 0} />
            </div>
          </div>
          <div className="hidden lg:block">
            <CurrentlyReadingProgress
              book={book}
              edition={userBookRead?.edition || userBook?.edition || edition}
              isOwner={isOwner}
              onProgressChange={onProgressChange}
              trackRead={trackRead}
              userBook={userBook}
              userBookRead={userBookRead}
            />
          </div>
        </div>

        <div className="relative -mt-12 lg:-mt-16 flex-none flex flex-col space-y-2 items-center">
          <ResponsiveCoverLink
            book={book}
            edition={userBookRead?.edition || userBook?.edition || edition}
            size="lg"
            sizeLg="lg"
            sizeSm="md"
            variant="secondary"
            settings={{
              tooltip: true,
              showStatus: true,
              details: true,
              stretch: "x",
            }}
          />

          <div
            className="absolute lg:hidden flex-none"
            style={{ right: "-40px", bottom: "-40px" }}
          >
            <CircleBookProgress progress={userBookRead?.progress || 0} />
          </div>
        </div>
      </div>
      <div className="lg:hidden">
        <CurrentlyReadingProgress
          userBook={userBook}
          book={book}
          isOwner={isOwner}
          edition={userBookRead?.edition || userBook?.edition || edition}
          onProgressChange={onProgressChange}
          userBookRead={userBookRead}
          trackRead={trackRead}
        />
      </div>
    </div>
  );
}
